import { useEffect } from 'react';
import { LoyaltyAccountEvents, LoyaltyPointsEvents } from 'actions/loyalty';
import { useStoreon } from 'storeon/react';
import { ISavedLoyaltyAccountData, savedLoyaltyAccountData } from 'common/utils/saved-loyalty-account-data';
import { LoyaltyStore } from 'reducers/loyalty';
import { getCustomerId } from 'selectors';

interface IUseLoyaltyAccount {
  enabled: boolean;
}

export enum ELoyaltyCustomEvents {
  LOYALTY_CREATED = 'LOYALTY_CREATED',
}

export const useLoyaltyAccount = ({ enabled }: IUseLoyaltyAccount) => {
  const { cookies } = useStoreon('cookies');
  const customerNumber = getCustomerId(cookies);
  const { dispatch, loyalty } = useStoreon<LoyaltyStore>('loyalty');

  useEffect(() => {
    const dispatchInit = () => {
      dispatch(LoyaltyAccountEvents.init);
    };

    if (enabled && customerNumber) {
      window.addEventListener(ELoyaltyCustomEvents.LOYALTY_CREATED, dispatchInit);

      const restoredLoyaltyAccount: ISavedLoyaltyAccountData = savedLoyaltyAccountData(customerNumber);

      if (restoredLoyaltyAccount) {
        dispatch(LoyaltyAccountEvents.restoreAccount, {
          loyaltyAccountIdentifier: restoredLoyaltyAccount.loyaltyAccountIdentifier,
          loyaltyTypePRO: restoredLoyaltyAccount.loyaltyTypePRO,
        });
      } else {
        dispatch(LoyaltyAccountEvents.init);
      }
    }

    return () => {
      window.removeEventListener(ELoyaltyCustomEvents.LOYALTY_CREATED, dispatchInit);
    };
  }, [enabled, dispatch, customerNumber]);

  useEffect(() => {
    if (loyalty.loyaltyAccountIdentifier) {
      const loyaltyActions: string[] = [
        LoyaltyPointsEvents.init,
        // ...(loyalty.loyaltyTypePRO ? [LoyaltyRankEvents.init] : []), Нужно включить в следующей итерации дизайна
      ];

      Promise.all([loyaltyActions.forEach((action) => dispatch(action))]);
    }
  }, [loyalty.loyaltyAccountIdentifier, dispatch, loyalty.loyaltyTypePRO]);
};
